/**
 * Shared visual constants for the arbitration module.
 * جدا از کامپوننت‌ها تا import چرخه‌ای (Header ↔ Panel) پیش نیاید.
 */

import { DisputeType } from '../../services/arbitrationService';

/** رنگ هویتی هر نوع اختلاف (hex — برای تینت‌های alpha در هر دو تم) */
export const TYPE_HEX: Record<DisputeType, string> = {
  [DisputeType.ORDER]: '#0ea5e9',
  [DisputeType.ORDER_ITEM]: '#0ea5e9',
  [DisputeType.INSPECTION]: '#10b981'
};
